import { CAT_NEWS } from 'App/utils/Collections';

export default {
  category: CAT_NEWS,
  filters: [],
};
